import { render } from "./timeTable.vue?vue&type=template&id=0370241b"
import script from "./timeTable.vue?vue&type=script&lang=js"
export * from "./timeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__